import { BadgeProps, Badge as MuiBadge, Tooltip, styled } from '@mui/material';

const Badge = styled(MuiBadge)(({ theme }) => ({
  padding: theme.spacing(theme.spacingSizes.xs),
  display: 'flex',
  width: theme.spacing(theme.spacingSizes.lg),
  height: theme.spacing(theme.spacingSizes.lg),
  justifyContent: 'center',
  alignItems: 'center',

  '& .MuiBadge-dot': {
    transform: 'none',
    display: 'block',
    position: 'static',
  },
}));

type Props = {
  color: BadgeProps['color'];
  tooltip?: string;
};

const StatusBadge: React.FC<Props> = ({ color, tooltip }) => {
  const badge = <Badge variant="dot" color={color} />;
  if (tooltip) {
    return <Tooltip title={tooltip}>{badge}</Tooltip>;
  }
  return badge;
};

export default StatusBadge;
